import _objectWithoutProperties from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectDestructuringEmpty from "/home/runner/work/Project-Evo/Project-Evo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty";
var _excluded = ["fillColor", "strokeColor", "strokeWidth", "size"];
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { withSubcomponents } from '../utils.js';
var Path = function Path(_ref) {
  var args = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx("path", _objectSpread({
      d: "M15.5345 12.3883C14.7543 12.0476 13.9057 11.9073 13.0675 11.9655L10.8768 5.40325\n         C12.1546 4.89731 13.5605 4.64544 15.0245 4.71429C16.4622 4.78315 17.8109 5.15317 19.019 5.75639\n         C18.8111 6.15273 17.9943 7.70718 17.1962 9.22574C16.4666 10.6141 15.7528 11.9725 15.5345 12.3883Z"
    }, args)), /* @__PURE__ */jsx("path", _objectSpread({
      d: "M11.3408 12.3901C10.6129 12.7091 9.96572 13.1542 9.41907 13.6965L5.32676 10.8794\n         C6.18828 8.76943 7.75589 7.03215 9.72589 5.94474L11.816 12.208C11.6562 12.2618 11.4967 12.3213 11.3408 12.3901Z"
    }, args)), /* @__PURE__ */jsx("path", _objectSpread({
      d: "M18.0718 22.8498C21.3517 21.5665 23.6531 18.6218 23.8331 14.8803\n         C23.9925 11.5595 22.357 8.56776 19.7742 6.83536L16.0155 13.987L15.4841 13.6672\n         C14.4671 13.0573 13.2095 12.9782 12.1247 13.4549C10.9746 13.9595 10.0917 14.8794 9.63658 16.045\n         C9.18372 17.2106 9.21364 18.4824 9.72099 19.6257C10.394 21.1431 11.6767 22.4993 13.3555 23.0039\n         C14.9477 23.4841 16.6453 23.4077 18.0718 22.8498Z"
    }, args)), /* @__PURE__ */jsx("path", _objectSpread({
      d: "M8.09978 20.7105C7.83226 20.1073 7.66388 19.4778 7.59466 18.8413L5.57686 18.8999\n         C6.54735 20.9019 8.18061 22.5388 10.2042 23.5156C9.30206 22.7383 8.57453 21.7806 8.09978 20.7105Z"
    }, args)), /* @__PURE__ */jsx("path", _objectSpread({
      d: "M7.58439 17.5842C7.63888 17.0089 7.77197 16.4368 7.98768 15.8833C8.15382 15.4533 8.36686 15.0482 8.61651 14.6733\n         L4.91097 12.1218C4.74349 12.7677 4.63898 13.4402 4.60504 14.1327C4.54653 15.3632 4.71714 16.551 5.07666 17.6575\n         L7.58439 17.5842Z"
    }, args))]
  });
};
var ViewBox = "0 0 28 28";
var _Minmatar = forwardRef(function (_ref2, ref) {
  var _ref2$fillColor = _ref2.fillColor,
    fillColor = _ref2$fillColor === void 0 ? "#FE3743" : _ref2$fillColor,
    _ref2$strokeColor = _ref2.strokeColor,
    strokeColor = _ref2$strokeColor === void 0 ? "black" : _ref2$strokeColor,
    _ref2$strokeWidth = _ref2.strokeWidth,
    strokeWidth = _ref2$strokeWidth === void 0 ? 0 : _ref2$strokeWidth,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 28 : _ref2$size,
    rest = _objectWithoutProperties(_ref2, _excluded);
  return /* @__PURE__ */jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    width: size,
    height: size,
    viewBox: ViewBox,
    fill: "none",
    paintOrder: "stroke"
  }, rest), {}, {
    children: /* @__PURE__ */jsx(Path, {
      fill: fillColor,
      stroke: strokeColor,
      strokeWidth: strokeWidth
    })
  }));
});
_Minmatar.displayName = "Minmatar";
var Minmatar = withSubcomponents(_Minmatar, {
  Path: Path,
  ViewBox: ViewBox
});
export { Minmatar };